export default "__VITE_ASSET__CUQSxBVX__"